export default __webpack_public_path__ + "static/media/final.286c0d3c.wav";